import { __extends } from "tslib";
import { FreeCamera } from "./freeCamera";
import { Quaternion, Vector3 } from "../Maths/math.vector";
import { Node } from "../node";
import "./Inputs/freeCameraDeviceOrientationInput";
import { Axis } from '../Maths/math.axis';
Node.AddNodeConstructor("DeviceOrientationCamera", function (name, scene) {
    return function () { return new DeviceOrientationCamera(name, Vector3.Zero(), scene); };
});
// We're mainly based on the logic defined into the FreeCamera code
/**
 * This is a camera specifically designed to react to device orientation events such as a modern mobile device
 * being tilted forward or back and left or right.
 */
var DeviceOrientationCamera = /** @class */ (function (_super) {
    __extends(DeviceOrientationCamera, _super);
    /**
     * Creates a new device orientation camera
     * @param name The name of the camera
     * @param position The start position camera
     * @param scene The scene the camera belongs to
     */
    function DeviceOrientationCamera(name, position, scene) {
        var _this = _super.call(this, name, position, scene) || this;
        _this._tmpDragQuaternion = new Quaternion();
        _this._disablePointerInputWhenUsingDeviceOrientation = true;
        _this._dragFactor = 0;
        _this._quaternionCache = new Quaternion();
        _this.inputs.addDeviceOrientation();
        // When the orientation sensor fires it's first event, disable mouse input
        if (_this.inputs._deviceOrientationInput) {
            _this.inputs._deviceOrientationInput._onDeviceOrientationChangedObservable.addOnce(function () {
                if (_this._disablePointerInputWhenUsingDeviceOrientation) {
                    if (_this.inputs._mouseInput) {
                        _this.inputs._mouseInput._allowCameraRotation = false;
                        _this.inputs._mouseInput.onPointerMovedObservable.add(function (e) {
                            if (_this._dragFactor != 0) {
                                if (!_this._initialQuaternion) {
                                    _this._initialQuaternion = new Quaternion();
                                }
                                // Rotate the initial space around the y axis to allow users to "turn around" via touch/mouse
                                Quaternion.FromEulerAnglesToRef(0, e.offsetX * _this._dragFactor, 0, _this._tmpDragQuaternion);
                                _this._initialQuaternion.multiplyToRef(_this._tmpDragQuaternion, _this._initialQuaternion);
                            }
                        });
                    }
                }
            });
        }
        return _this;
    }
    Object.defineProperty(DeviceOrientationCamera.prototype, "disablePointerInputWhenUsingDeviceOrientation", {
        /**
         * Gets or sets a boolean indicating that pointer input must be disabled on first orientation sensor update (Default: true)
         */
        get: function () {
            return this._disablePointerInputWhenUsingDeviceOrientation;
        },
        set: function (value) {
            this._disablePointerInputWhenUsingDeviceOrientation = value;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Enabled turning on the y axis when the orientation sensor is active
     * @param dragFactor the factor that controls the turn speed (default: 1/300)
     */
    DeviceOrientationCamera.prototype.enableHorizontalDragging = function (dragFactor) {
        if (dragFactor === void 0) { dragFactor = 1 / 300; }
        this._dragFactor = dragFactor;
    };
    /**
     * Gets the current instance class name ("DeviceOrientationCamera").
     * This helps avoiding instanceof at run time.
     * @returns the class name
     */
    DeviceOrientationCamera.prototype.getClassName = function () {
        return "DeviceOrientationCamera";
    };
    /**
     * @hidden
     * Checks and applies the current values of the inputs to the camera. (Internal use only)
     */
    DeviceOrientationCamera.prototype._checkInputs = function () {
        _super.prototype._checkInputs.call(this);
        this._quaternionCache.copyFrom(this.rotationQuaternion);
        if (this._initialQuaternion) {
            this._initialQuaternion.multiplyToRef(this.rotationQuaternion, this.rotationQuaternion);
        }
    };
    /**
     * Reset the camera to its default orientation on the specified axis only.
     * @param axis The axis to reset
     */
    DeviceOrientationCamera.prototype.resetToCurrentRotation = function (axis) {
        var _this = this;
        if (axis === void 0) { axis = Axis.Y; }
        //can only work if this camera has a rotation quaternion already.
        if (!this.rotationQuaternion) {
            return;
        }
        if (!this._initialQuaternion) {
            this._initialQuaternion = new Quaternion();
        }
        this._initialQuaternion.copyFrom(this._quaternionCache || this.rotationQuaternion);
        ['x', 'y', 'z'].forEach(function (axisName) {
            if (!axis[axisName]) {
                _this._initialQuaternion[axisName] = 0;
            }
            else {
                _this._initialQuaternion[axisName] *= -1;
            }
        });
        this._initialQuaternion.normalize();
        //force rotation update
        this._initialQuaternion.multiplyToRef(this.rotationQuaternion, this.rotationQuaternion);
    };
    return DeviceOrientationCamera;
}(FreeCamera));
export { DeviceOrientationCamera };
//# sourceMappingURL=deviceOrientationCamera.js.map